<ng-container *transloco="let t">
  <div class="relative border-b-5 border-vermilion-100 pt-2xl md:pt-12.5">
    <div class="h-layout pb-2xl pt-navbar-thin md:pt-lg">
      <div class="relative">
        <div class="w-full text-center text-secondary">
          <div class="flex flex-col items-center">
            <h1
              class="text-shadow mt-xl pb-md font-bold leading-tight heading-2xl md:pb-xs md:heading-4xl"
              [innerHTML]="t('homepage2.title')"
            ></h1>
            <div class="flex items-center justify-center">
              <div
                class="flex w-1/2 min-w-[220px] flex-col flex-wrap items-center justify-center gap-x-md gap-y-sm pb-xl font-bold md:w-full md:flex-row md:gap-y-0"
              >
                <div class="flex flex-row gap-x-md">
                  <cft-benefit iconColor="bg-petrol-100">
                    <p class="text-shadow text-[16px]">{{ t('homepage.benefits.1') }}</p>
                  </cft-benefit>
                  <cft-benefit iconColor="bg-gold-100">
                    <p class="text-shadow text-[16px]">{{ t('homepage.benefits.2') }}</p>
                  </cft-benefit>
                </div>
                <div class="flex flex-row gap-x-md">
                  <cft-benefit iconColor="bg-purple-100">
                    <p class="text-shadow text-[16px]">{{ t('homepage.benefits.3') }}</p>
                  </cft-benefit>
                  <cft-benefit iconColor="bg-rivergreen-500">
                    <p class="text-shadow text-[16px]">{{ t('homepage.benefits.4') }}</p>
                  </cft-benefit>
                </div>
              </div>
            </div>
            <div class="flex w-full items-center justify-center">
              <div
                class="search-bar mb-xl block w-full max-w-[570px] cursor-pointer rounded-full bg-white px-xs py-xs md:max-w-[650px]"
                (click)="openSearch()"
              >
                <div class="ml-xl flex items-center justify-between md:ml-2xl">
                  <div class="flex flex-col text-left">
                    <span class="mb-2xs hidden text-sm font-semibold text-president-100 md:inline-flex">{{
                      t('homepage.searchBar.title')
                    }}</span>
                    <span class="text-sm text-president-90">{{ t('homepage.searchBar.subtitle') }}</span>
                  </div>
                  <div>
                    <button
                      class="search-button-animation text-animation btn btn-vermilion flex h-[34px] w-[34px] justify-center rounded-full p-0 text-base md:h-[46px] md:w-[46px]"
                    >
                      <fa-icon [icon]="searchIcon" class="font-normal"></fa-icon>
                      <p class="button-text absolute opacity-0 transition-opacity">click me</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- info table -->
            <div class="max-w-full rounded-lg border border-grey-50 shadow-6 md:w-[625px] md:shadow-none">
              <div class="m-auto items-center justify-center overflow-x-scroll rounded-lg no-scrollbar">
                <div class="flex justify-start rounded-lg">
                  <div class="tile-background flex w-full rounded-lg">
                    <div class="info-tile border-r">
                      <p class="info-tile-label">
                        {{ t('homepage.infoGrid.1.label') }}
                      </p>
                      <p class="info-tile-value">
                        {{ t('homepage.infoGrid.1.value') }}
                      </p>
                    </div>
                    <div class="info-tile border-r">
                      <p class="info-tile-label">
                        {{ t('homepage.infoGrid.2.label') }}
                      </p>
                      <p class="info-tile-value">
                        {{ t('homepage.infoGrid.2.value') }}
                      </p>
                    </div>
                    <div class="info-tile border-r">
                      <p class="info-tile-label">
                        {{ t('homepage.infoGrid.3.label') }}
                      </p>
                      <p class="info-tile-value">
                        {{ t('homepage.infoGrid.3.value') }}
                      </p>
                    </div>
                    <div class="info-tile">
                      <p class="info-tile-label">
                        {{ t('homepage.infoGrid.4.label') }}
                      </p>
                      <p class="info-tile-value">{{ t('homepage.infoGrid.4.value') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    desktop selling points-->
    <div class="hidden md:block">
      <cft-selling-point-bar class="py-xs" [hasSolidBackground]="true" mdGapSize="xl">
        <cft-selling-point-item class="p-xs">
          <div class="flex">
            <cft-google-rating
              class="inline-flex text-primary"
              [numReviews]="t('siteRating.numReviews')"
              [rating]="t('siteRating.rating')"
            ></cft-google-rating>
          </div>
        </cft-selling-point-item>
        <cft-selling-point-item class="p-xs">
          <p (click)="showHappinessDialog()" class="cursor-pointer">
            {{ t('shared.sellingPoints.guaranteeText') }}
            <fa-icon [icon]="happinessIcon"></fa-icon>
          </p>
        </cft-selling-point-item>
        <cft-selling-point-item class="p-xs">
          <div class="flex min-w-[140px] flex-col items-center justify-center lg:flex-row">
            <p>{{ t('shared.mobiPartnership.title') }}</p>
            <bgo-mobiliar-logo size="xs" [negative]="true" class="pl-2xs"></bgo-mobiliar-logo>
          </div>
        </cft-selling-point-item>
      </cft-selling-point-bar>
    </div>

    <!--    mobile carousel-->
    <div class="w-full text-white md:hidden">
      <cft-list-carousel
        class="border-t border-white bg-president-90"
        navigationType="ghost"
        navigationColor="text-white"
        [hasShadow]="false"
      >
        <div cftListCarouselSlide class="flex flex-col items-center justify-center py-xs">
          <cft-google-rating
            class="text-primary"
            [rating]="t('siteRating.rating')"
            [numReviews]="t('siteRating.numReviews')"
          ></cft-google-rating>
        </div>
        <div class="flex items-center justify-center py-xs text-center" cftListCarouselSlide>
          <p (click)="showHappinessDialog()" class="w-8/12 cursor-pointer">
            {{ t('shared.sellingPoints.guaranteeText') }}
            <fa-icon [icon]="happinessIcon"></fa-icon>
          </p>
        </div>
        <div class="flex flex-col items-center justify-center py-sm" cftListCarouselSlide>
          <p>{{ t('offeringDirectory.sellingPoints.mobiText') }}</p>
          <bgo-mobiliar-logo size="xs" [negative]="true" class="pl-2xs"></bgo-mobiliar-logo>
        </div>
      </cft-list-carousel>
    </div>

    <cft-wave-cover-image class="-z-1">
      <img
        ngSrc="assets/images/home-cover-v6.jpg"
        class="banner-image"
        alt=""
        content="background-image"
        fill
        priority
      />
    </cft-wave-cover-image>
  </div>
</ng-container>
